export default {
  startLoading: 'Začať nakladanie',
  finishLoading: 'Dokončiť nakladanie',
  loadEditDisabled: 'Upravovať je možné iba "plánovanú" vsázku.',
};
